export default __webpack_public_path__ + "static/media/bannerImg.32d39a3d.svg";